var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlPanel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Control_Panel_48",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.92 0 0 0.92 24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_G2KCRoOkxknyaobVSaI3ha_1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: -5.385,
    y1: 10.444,
    x2: 66.913,
    y2: 43.798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(51,215,240)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "18.7%",
    style: {
      stopColor: "rgb(47,209,237)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "44.5%",
    style: {
      stopColor: "rgb(36,191,227)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "74.4%",
    style: {
      stopColor: "rgb(19,162,212)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,131,196)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_G2KCRoOkxknyaobVSaI3ha_1)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -24)",
    d: "M 43 8 L 5 8 C 3.895 8 3 8.895 3 10 L 3 38 C 3 39.105 3.895 40 5 40 L 43 40 C 44.105 40 45 39.105 45 38 L 45 10 C 45 8.895 44.105 8 43 8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8 -3)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(3,112,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.53 -7.47)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_G2KCRoOkxknyaobVSaI3hb_2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 18.287,
    y1: 12.6,
    x2: 21.887,
    y2: 24.489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,209,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(227,96,1)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_G2KCRoOkxknyaobVSaI3hb_2)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-20.47, -16.53)",
    d: "M 16 20 L 16 13.07 C 16 12.471 16.525 11.996 17.12 12.07 C 19.094 12.318 20.943 13.215 22.364 14.636 C 23.785 16.057 24.682000000000002 17.906 24.93 19.88 C 25.005 20.474999999999998 24.53 21 23.93 21 L 17 21 C 16.448 21 16 20.552 16 20 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 7 11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(3,112,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-31, -35)",
    d: "M 38.5 36 L 24 36 L 23 35 L 24 34 L 38.5 34 C 38.776 34 39 34.224 39 34.5 L 39 35.5 C 39 35.776 38.776 36 38.5 36 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.5 11)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_G2KCRoOkxknyaobVSaI3hc_3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 13.734,
    y1: 31.545,
    x2: 21.96,
    y2: 41.348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,209,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(227,96,1)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_G2KCRoOkxknyaobVSaI3hc_3)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16.5, -35)",
    d: "M 24 34 L 24 36 L 9.5 36 C 9.224 36 9 35.776 9 35.5 L 9 34.5 C 9 34.224 9.224 34 9.5 34 L 24 34 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.5 -9.5)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_G2KCRoOkxknyaobVSaI3hd_4",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 32.296,
    y1: 11.874,
    x2: 36.704,
    y2: 17.126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,209,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(227,96,1)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_G2KCRoOkxknyaobVSaI3hd_4)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-34.5, -14.5)",
    d: "M 37.5 16 L 31.5 16 C 30.672 16 30 15.328 30 14.5 L 30 14.5 C 30 13.672 30.672 13 31.5 13 L 37.5 13 C 38.328 13 39 13.672 39 14.5 L 39 14.5 C 39 15.328 38.328 16 37.5 16 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(3,112,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-34.5, -20.5)",
    d: "M 37.5 22 L 31.5 22 C 30.672 22 30 21.328 30 20.5 L 30 20.5 C 30 19.672 30.672 19 31.5 19 L 37.5 19 C 38.328 19 39 19.672 39 20.5 L 39 20.5 C 39 21.328 38.328 22 37.5 22 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.5 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(3,112,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-34.5, -26.5)",
    d: "M 37.5 28 L 31.5 28 C 30.672 28 30 27.328 30 26.5 L 30 26.5 C 30 25.672 30.672 25 31.5 25 L 37.5 25 C 38.328 25 39 25.672 39 26.5 L 39 26.5 C 39 27.328 38.328 28 37.5 28 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlPanel);
export default __webpack_public_path__ + "static/media/control_panel.ac7de93b5ba49d604495c2ada192b201.svg";
export { ForwardRef as ReactComponent };